import flatten from 'lodash/flatten';

import availableLanguages from '../data/i18n/available-languages';

export default function getDefaultLocale() {
    let preferredLanguages = ['en'];
    if (typeof navigator != 'undefined') {
        preferredLanguages = [...(navigator.languages || []), navigator.language, ...preferredLanguages, 'en'];
    }

    return flatten(preferredLanguages.filter(i => i).map(locale => locale.match(/\w\w/)))
        .map(locale => locale.toLowerCase())
        .filter(i => i)
        .find(locale => availableLanguages.includes(locale));
}
